module.exports = __webpack_public_path__ + "static/media/github.7b3d66fe.svg";